// Cart Timer Functionality
// Timer duration in minutes - will be read from data attribute
const TIMER_STORAGE_KEY = 'cart_timer_end_time';

// Function to get timer duration from cart drawer element
function getTimerDuration() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && cartDrawer.dataset.timerDuration) {
    const duration = parseInt(cartDrawer.dataset.timerDuration);
    return duration && duration > 0 ? duration : 20; // Default to 20 if invalid
  }
  return 20; // Default to 20 minutes
}

class CartTimer {
  constructor() {
    this.timerElement = null;
    this.countdownElement = null;
    this.intervalId = null;
    this.endTime = null;
    this.cartUpdateUnsubscriber = null;
    
    this.init();
  }

  init() {
    // Wait for DOM and dependencies to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeTimer());
    } else {
      // If DOM is ready but scripts might not be, wait a bit
      setTimeout(() => this.initializeTimer(), 100);
    }
  }

  initializeTimer() {
    this.timerElement = document.getElementById('CartDrawer-Timer');
    this.countdownElement = document.getElementById('CartDrawer-Timer-Countdown');
    
    // Check if cart has items
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      // Retry if cart drawer not found yet
      setTimeout(() => this.initializeTimer(), 200);
      return;
    }

    // Check if timer exists in localStorage
    const storedEndTime = localStorage.getItem(TIMER_STORAGE_KEY);
    
    if (storedEndTime) {
      this.endTime = parseInt(storedEndTime);
      const now = Date.now();
      
      // If timer has expired, restart it
      if (now >= this.endTime) {
        this.startTimer();
      } else {
        // Timer is still active, continue it
        if (this.timerElement && this.countdownElement) {
          this.showTimer();
          this.updateCountdown();
          
          // Clear any existing interval
          if (this.intervalId) {
            clearInterval(this.intervalId);
          }
          
          // Start countdown interval
          this.intervalId = setInterval(() => {
            this.updateCountdown();
          }, 1000);
        }
      }
    } else {
      // No timer exists, check if cart has items
      const cartItems = document.querySelectorAll('.wt-cart__list .wt-cart__item');
      const isCartEmpty = cartDrawer.classList.contains('wt-cart--empty');
      if (cartItems.length > 0 && !isCartEmpty) {
        this.startTimer();
      }
    }

    // Listen for cart updates (when items are added)
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // Unsubscribe previous listener if exists
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // Wait for DOM to update after cart refresh (renderContents may be called after this event)
        // Use multiple attempts to find timer element as DOM updates
        let attempts = 0;
        const maxAttempts = 15; // Increased attempts to wait for renderContents
        
        const checkAndStartTimer = () => {
          attempts++;
          // Re-get elements in case they were replaced
          this.timerElement = document.getElementById('CartDrawer-Timer');
          this.countdownElement = document.getElementById('CartDrawer-Timer-Countdown');
          
          const cartItems = document.querySelectorAll('.wt-cart__list .wt-cart__item');
          const cartDrawer = document.querySelector('cart-drawer');
          const isCartEmpty = cartDrawer && cartDrawer.classList.contains('wt-cart--empty');
          
          if (cartItems.length > 0 && !isCartEmpty) {
            // If timer element exists, start timer
            if (this.timerElement && this.countdownElement) {
              this.startTimer();
            } else if (attempts < maxAttempts) {
              // Retry after a short delay if element not found yet
              setTimeout(checkAndStartTimer, 150);
            }
          } else {
            // Cart is empty, hide timer
            this.hideTimer();
            if (this.intervalId) {
              clearInterval(this.intervalId);
              this.intervalId = null;
            }
          }
        };
        
        // Start checking after initial delay (wait for renderContents to complete)
        setTimeout(checkAndStartTimer, 200);
      });
    }

    // Also listen for cart-drawer:rendered event (dispatched after renderContents completes)
    document.addEventListener('cart-drawer:rendered', () => {
      // Re-initialize timer after drawer is rendered
      let attempts = 0;
      const maxAttempts = 10;
      
      const checkAndStartTimer = () => {
        attempts++;
        this.timerElement = document.getElementById('CartDrawer-Timer');
        this.countdownElement = document.getElementById('CartDrawer-Timer-Countdown');
        
        if (this.timerElement && this.countdownElement) {
          const cartItems = document.querySelectorAll('.wt-cart__list .wt-cart__item');
          const cartDrawer = document.querySelector('cart-drawer');
          const isCartEmpty = cartDrawer && cartDrawer.classList.contains('wt-cart--empty');
          
          if (cartItems.length > 0 && !isCartEmpty) {
            const storedEndTime = localStorage.getItem(TIMER_STORAGE_KEY);
            if (storedEndTime) {
              this.endTime = parseInt(storedEndTime);
              const now = Date.now();
              if (now >= this.endTime) {
                this.startTimer();
              } else {
                this.showTimer();
                this.updateCountdown();
                
                // Clear any existing interval
                if (this.intervalId) {
                  clearInterval(this.intervalId);
                }
                
                // Start countdown interval
                this.intervalId = setInterval(() => {
                  this.updateCountdown();
                }, 1000);
              }
            } else {
              this.startTimer();
            }
          } else {
            // Cart is empty, hide timer
            this.hideTimer();
            if (this.intervalId) {
              clearInterval(this.intervalId);
              this.intervalId = null;
            }
          }
        } else if (attempts < maxAttempts) {
          // Retry after a short delay
          setTimeout(checkAndStartTimer, 100);
        }
      };
      
      // Start checking after initial delay
      setTimeout(checkAndStartTimer, 50);
    });

    // Listen for cart drawer refresh
    document.addEventListener('cart-drawer:refresh', () => {
      // Re-initialize timer after drawer refresh
      // Use multiple attempts to find timer element as DOM updates
      let attempts = 0;
      const maxAttempts = 10;
      
      const checkAndStartTimer = () => {
        attempts++;
        this.timerElement = document.getElementById('CartDrawer-Timer');
        this.countdownElement = document.getElementById('CartDrawer-Timer-Countdown');
        
        if (this.timerElement && this.countdownElement) {
          const cartItems = document.querySelectorAll('.wt-cart__list .wt-cart__item');
          const cartDrawer = document.querySelector('cart-drawer');
          const isCartEmpty = cartDrawer && cartDrawer.classList.contains('wt-cart--empty');
          
          if (cartItems.length > 0 && !isCartEmpty) {
            const storedEndTime = localStorage.getItem(TIMER_STORAGE_KEY);
            if (storedEndTime) {
              this.endTime = parseInt(storedEndTime);
              const now = Date.now();
              if (now >= this.endTime) {
                this.startTimer();
              } else {
                this.showTimer();
                this.updateCountdown();
                
                // Clear any existing interval
                if (this.intervalId) {
                  clearInterval(this.intervalId);
                }
                
                // Start countdown interval
                this.intervalId = setInterval(() => {
                  this.updateCountdown();
                }, 1000);
              }
            } else {
              this.startTimer();
            }
          } else {
            // Cart is empty, hide timer
            this.hideTimer();
            if (this.intervalId) {
              clearInterval(this.intervalId);
              this.intervalId = null;
            }
          }
        } else if (attempts < maxAttempts) {
          // Retry after a short delay
          setTimeout(checkAndStartTimer, 100);
        }
      };
      
      // Start checking after initial delay
      setTimeout(checkAndStartTimer, 100);
    });
  }

  startTimer() {
    // Re-get elements to ensure we have the latest references
    this.timerElement = document.getElementById('CartDrawer-Timer');
    this.countdownElement = document.getElementById('CartDrawer-Timer-Countdown');
    
    // If elements don't exist yet, wait a bit and retry
    if (!this.timerElement || !this.countdownElement) {
      setTimeout(() => {
        this.timerElement = document.getElementById('CartDrawer-Timer');
        this.countdownElement = document.getElementById('CartDrawer-Timer-Countdown');
        if (this.timerElement && this.countdownElement) {
          this.startTimer();
        }
      }, 200);
      return;
    }
    
    // Get timer duration from data attribute
    const timerDuration = getTimerDuration();
    
    // Set end time based on configured duration
    this.endTime = Date.now() + (timerDuration * 60 * 1000);
    
    // Store in localStorage
    localStorage.setItem(TIMER_STORAGE_KEY, this.endTime.toString());
    
    // Show timer immediately
    this.showTimer();
    
    // Start countdown
    this.updateCountdown();
    
    // Clear any existing interval
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    
    // Update countdown every second
    this.intervalId = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  showTimer() {
    if (this.timerElement) {
      this.timerElement.style.display = 'block';
    }
  }

  hideTimer() {
    if (this.timerElement) {
      this.timerElement.style.display = 'none';
    }
  }

  updateCountdown() {
    if (!this.countdownElement || !this.endTime) return;

    const now = Date.now();
    const timeRemaining = this.endTime - now;

    if (timeRemaining <= 0) {
      // Timer expired, restart it
      this.startTimer();
      return;
    }

    // Calculate minutes and seconds
    const minutes = Math.floor(timeRemaining / (60 * 1000));
    const seconds = Math.floor((timeRemaining % (60 * 1000)) / 1000);

    // Format as MM:SS
    const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    
    // Update display
    this.countdownElement.textContent = formattedTime;
  }

  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
      this.cartUpdateUnsubscriber = null;
    }
  }
}

// Initialize timer when DOM is ready
// Only create one instance
if (!window.cartTimer) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.cartTimer = new CartTimer();
    });
  } else {
    window.cartTimer = new CartTimer();
  }
}

